import React, { useEffect, useState, ReactNode, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './scss/huring.scss';
import SubTitle from '../component/sub-title';
import Color from '@/tool/color';

import Tab from '../component/tab';
import TimeTab from '../component/time-tab';
import moHuring, { huringActiveChange } from './store/huring';
import HuringChart from './component/huring-chart';
import HeadTable from '../component/head-table';
import Empty from '@/component/empty';
import { toJS } from 'mobx';
import MainTitle from '../component/main-title';



interface IProps { }
interface IState { }

const HuringRevenue = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { huringActiveShow, huringList } = moHuring;

  const changeShow = (val: string) => {
    huringActiveChange(val);
  };

  const goInsight = () => {
    window.open('/market/insight', '_blank');
  };

  const titleList = useMemo(() => {
    const list: any = [];
    huringList?.forEach((res: any) => {
      list.push(res.company_name);
    });
    return list;
  }, [huringList]);

  const tableList = useMemo(() => {
    let list: any = [];
    if (!isEmpty(huringList)) {
      list = huringList[0].data.map((res: any, r: any) => {
        const item: any = {};
        item.industry = res.quarter;
        const subList: any = [];
        huringList.forEach((ele: any) => {
          subList.push({
            revenue: ele.data[r].revenue,
            count: ele.data[r].count,
          });
        });
        item.child = subList;
        return item;
      });
    }
    return list;
  }, [huringList]);

  useEffect(() => {
    return () => { };
  }, []);

  return (
    <section id="effect07" className="huring-revenue-warp-pdf human-common-pdf">

      <MainTitle
        title='招聘量与营收'
        subtitle='我所在行业前三名'
        bgcolor={Color.primaryColor(0.1)}
        color={Color.primary} />

      {!isEmpty(huringList) ? <section className='huring-content'>
        {
          huringList?.map((res: any, r: any) => {
            return <section key={`${r}`} className="huring-content-item"
              style={{ width: '50%' }}>
              <p className='title'>{res.company_name}</p>
              <HuringChart list={res.data} key={`${r}`} />
            </section>;
          })
        }
      </section> : <Empty />}

    </section>
  );
};

export default observer(HuringRevenue);
